import React from 'react';

import { UiKit } from 'components';
import { ReactComponent as InfoIcon } from 'assets/img/icons/info-icon.svg';

export default function InfoLink({
  url = '',
  message = 'Know More',
  className = '',
  infoOnly = false
}) {
  if (!url && !infoOnly) return null;

  return (
    <UiKit.Tooltip>
      <UiKit.Tooltip.Trigger>
        <a
          href={url}
          target="_blank"
          onClick={!infoOnly ? () => {} : e => e.preventDefault()}
          rel="noopener noreferrer"
          className={className}
        >
          <InfoIcon />
        </a>
      </UiKit.Tooltip.Trigger>
      <UiKit.Tooltip.Content boundariesElement="viewport">
        {message}
      </UiKit.Tooltip.Content>
    </UiKit.Tooltip>
  );
}
